// extracted by mini-css-extract-plugin
export default {"Codeshare":"Codeshare_Codeshare__YTc5N"};